import { Injectable } from '@angular/core';
import { PriceListModel } from '../../../models/centre/price.model';
import { CentreUrl } from '../../../shared/urls/centre.url';
import { BaseService } from '../../../shared/services/base.service';
import { PriceUrl } from '../../../shared/urls/price.url';
import { UserUrl } from '../../../shared/urls/user.url';
import { ProductCategoryUrl } from '../../../shared/urls/master-data.productcategory.url';

@Injectable()
export class ManagePriceListService {
    constructor(public baseService: BaseService) {
    }

    getModelList() {
        let url = PriceUrl.GET_MODEL_PRICE;
        return this.baseService.getData(url);
        // return [
        //     { id: 'Vaccines' },
        //     { id: 'Consultation fees' },
        //     { id: 'Prescription fees' },
        //     { id: 'Lab tests' },
        //     { id: 'Products' }

        // ];
    }

    getDefaultCurrency(selectedCentre) {
        let url = PriceUrl.GET_DEFAULT_CURRENCY;
        let param = { centreId: selectedCentre };
        return this.baseService.getData(url, param);
    }

    getCentreList() {
        let url = UserUrl.GET_USER_CENTRES;
        return this.baseService.getData(url);
    }

    getCurrencies(selectedCentre) {
        let url = PriceUrl.GET_CURRENCIES;
        let param = { selectedCentreId: selectedCentre };
        return this.baseService.getData(url, param);
    }

    getPriceList(param) {
        let url = PriceUrl.GET_PRICE_LIST;
        return this.baseService.getData(url, param);
    }

    getPriceItemDetail(id) {
        return {
            clinicPrice: 50,
            costPrice: 30.85,
            defaultPrice: 50,
            id: "00000000-0000-0000-0000-000000000000",
            item: "ACWY Vax (Meningitis ACYW-135)",
            taxPrice: 0,
            currencyCode: 'EUR',
            categoryName: '',
            categoryId: ''
        };
    }

    removePriceItem(param) {
        const url = PriceUrl.DELETED_PRICE + `${param.id}`;
        //let modelId = param.modelId;
        return this.baseService.put(url, param);

    }
    addNewPrice(param){
        const url = PriceUrl.ADD_NEW_PRICE;
        return this.baseService.postData(url, param);
    }
    getProductCategoryList() {
        const url = ProductCategoryUrl.PRODUCTCATEGORY_GET_ALL;
        return this.baseService.getData(url);
    }

    getAddPriceList(param) {
        const url = PriceUrl.GET_PRICE_FOR_ADD;
        return this.baseService.getData(url, param);
    }
    updatePrice(id, param){
        const url = PriceUrl.UPDATE_PRICE + `${id}`;
        return this.baseService.put(url, param);
    }

    addNewPriceConsultation(param){
        const url = PriceUrl.ADD_NEW_PRICE_CONSULTATIONFEE;
        return this.baseService.postData(url, param);
    }

    getAddPriceListConsultation(id) {
        const url = PriceUrl.GET_PRICE_FOR_ADD_CONSULTATIONFEE + `${id}`;
        return this.baseService.getData(url);
    }
    updatePriceConsultation(id, param){
        const url = PriceUrl.UPDATE_PRICE_CONSULTATIONFEE.replace('{id}', id);
        return this.baseService.put(url, param);
    }

    removePriceConsultation(id) {
        const url = PriceUrl.DELETED_PRICE_CONSULTATIONFEE.replace('{id}',id);
        return this.baseService.delete(url);

    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-price/manage-price-list.service.ts